(function () {
  'use strict';

  var AUTOPLAY_MS = 5000;
  var MOBILE_MAX = 749;
  var SCROLL_SETTLE_MS = 130;     // debounce for "scroll has stopped"
  var TOUCH_RESUME_MS = 700;      // wait after touch before resuming autoplay

  function initCarousel(root) {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    var track = root.querySelector('[data-track]');
    if (!track) return;

    var realSlides = Array.prototype.slice.call(track.querySelectorAll('[data-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-dot]'));
    var numReal = realSlides.length;
    if (numReal === 0) return;

    var hasLoop = numReal > 1;
    var totalSlides = numReal;
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var autoplayMs = parseInt(root.getAttribute('data-autoplay-ms'), 10) || AUTOPLAY_MS;
    var timer = null;
    var settleTimer = null;
    var suppressSettle = false;
    var touchActive = false;
    var currentLogical = 0;

    // Clone first/last for seamless infinite loop
    if (hasLoop) {
      var firstClone = realSlides[0].cloneNode(true);
      var lastClone = realSlides[numReal - 1].cloneNode(true);
      [firstClone, lastClone].forEach(function (c) {
        c.setAttribute('aria-hidden', 'true');
        c.removeAttribute('data-slide');
        c.setAttribute('data-clone', '');
      });
      track.insertBefore(lastClone, realSlides[0]);
      track.appendChild(firstClone);
      totalSlides = numReal + 2;
    }

    function getWidth() {
      return track.clientWidth || 0;
    }

    function setScrollInstant(left) {
      var prev = track.style.scrollBehavior;
      suppressSettle = true;
      track.style.scrollBehavior = 'auto';
      track.scrollLeft = left;
      requestAnimationFrame(function () {
        track.style.scrollBehavior = prev || '';
        // settle suppression releases on the next animation frame
        requestAnimationFrame(function () { suppressSettle = false; });
      });
    }

    function setScrollSmooth(left) {
      try {
        track.scrollTo({ left: left, behavior: reducedMotion ? 'auto' : 'smooth' });
      } catch (e) {
        track.scrollLeft = left;
      }
    }

    function getDomIndex() {
      var width = getWidth();
      if (width === 0) return hasLoop ? 1 : 0;
      return Math.round(track.scrollLeft / width);
    }

    function domToLogical(dom) {
      if (!hasLoop) return dom;
      if (dom <= 0) return numReal - 1;
      if (dom >= totalSlides - 1) return 0;
      return dom - 1;
    }

    function logicalToDom(log) {
      return hasLoop ? log + 1 : log;
    }

    function updateDotsAndAria(logical) {
      currentLogical = logical;
      dots.forEach(function (d, i) {
        var active = i === logical;
        d.classList.toggle('is-active', active);
        d.setAttribute('aria-current', active ? 'true' : 'false');
      });
      realSlides.forEach(function (s, i) {
        var active = i === logical;
        s.classList.toggle('is-active', active);
        if (active) {
          s.removeAttribute('aria-hidden');
        } else {
          s.setAttribute('aria-hidden', 'true');
        }
      });
    }

    function onScrollSettled() {
      if (suppressSettle) return;
      var width = getWidth();
      if (width === 0) return;
      var dom = getDomIndex();

      // If we landed on a clone, silently jump to its real twin
      if (hasLoop && dom === 0) {
        setScrollInstant(numReal * width);
        updateDotsAndAria(numReal - 1);
        return;
      }
      if (hasLoop && dom === totalSlides - 1) {
        setScrollInstant(width);
        updateDotsAndAria(0);
        return;
      }

      updateDotsAndAria(domToLogical(dom));
    }

    track.addEventListener('scroll', function () {
      if (settleTimer) clearTimeout(settleTimer);
      settleTimer = setTimeout(onScrollSettled, SCROLL_SETTLE_MS);
    }, { passive: true });

    function next() {
      var width = getWidth();
      if (width === 0) return;
      setScrollSmooth(track.scrollLeft + width);
    }

    function goToLogical(log) {
      var width = getWidth();
      if (width === 0) return;
      setScrollSmooth(logicalToDom(log) * width);
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function (e) {
        e.preventDefault();
        goToLogical(i);
        resetTimer();
      });
    });

    // ---------------- Autoplay ----------------
    function stopTimer() {
      if (timer) { clearInterval(timer); timer = null; }
    }
    function startTimer() {
      stopTimer();
      if (reducedMotion) return;
      if (!hasLoop) return;
      if (document.hidden) return;
      if (touchActive) return;
      if (window.innerWidth > MOBILE_MAX) return;
      timer = setInterval(next, autoplayMs);
    }
    function resetTimer() { startTimer(); }

    // Pause autoplay while the user is actively touching
    track.addEventListener('touchstart', function () {
      touchActive = true;
      stopTimer();
    }, { passive: true });

    track.addEventListener('touchend', function () {
      // Let the native scroll settle before resuming the timer
      setTimeout(function () {
        touchActive = false;
        startTimer();
      }, TOUCH_RESUME_MS);
    }, { passive: true });

    track.addEventListener('touchcancel', function () {
      setTimeout(function () {
        touchActive = false;
        startTimer();
      }, TOUCH_RESUME_MS);
    }, { passive: true });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stopTimer();
      else startTimer();
    });

    var resizeRaf = null;
    window.addEventListener('resize', function () {
      if (resizeRaf) cancelAnimationFrame(resizeRaf);
      resizeRaf = requestAnimationFrame(function () {
        var width = getWidth();
        setScrollInstant(logicalToDom(currentLogical) * width);
        startTimer();
      });
    });

    try {
      var mq = window.matchMedia('(prefers-reduced-motion: reduce)');
      var mqHandler = function (e) {
        reducedMotion = e.matches;
        startTimer();
      };
      if (mq.addEventListener) mq.addEventListener('change', mqHandler);
      else if (mq.addListener) mq.addListener(mqHandler);
    } catch (err) { /* noop */ }

    // Initial anchor — wait two frames so layout (incl. aspect-ratio + flex sizing) is settled
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        var width = getWidth();
        setScrollInstant(logicalToDom(0) * width);
        updateDotsAndAria(0);
        startTimer();
      });
    });
  }

  function initAll(scope) {
    var root = scope || document;
    var carousels = root.querySelectorAll('[data-carousel]');
    Array.prototype.forEach.call(carousels, initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
